import { parse, isValid } from "date-fns";
import * as z from "zod";

import { clearMask } from "Helpers/Util";

const messages = {
  requiredField: "Campo obrigatório",
  minCharacters: (num) => `Mínimo de ${num} caracteres`,
  maxCharacters: (num) => `Máximo de ${num} caracteres`,
  exactCharacters: (num) => `Deve conter ${num} caracteres`,
};

const UserValidator = {
  full_name: z
    .string({ message: messages.requiredField })
    .min(5, { message: messages.minCharacters(5) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
  email: z
    .string({ message: messages.requiredField })
    .email({ message: "E-mail inválido" }),
  document: z
    .string({ message: messages.requiredField })
    .refine((val) => clearMask(val).length === 11, {
      message: messages.exactCharacters(11),
    })
    .or(
      z
        .string({ message: messages.requiredField })
        .refine((val) => clearMask(val).length === 14, {
          message: messages.exactCharacters(14),
        }),
    ),
  phone: z
    .string({ message: messages.requiredField })
    .refine((val) => clearMask(val).length === 13, {
      message: messages.exactCharacters(13),
    }),
  birth_date: z
    .string({ message: messages.requiredField })
    .refine((val) => clearMask(val).length === 8, {
      message: messages.exactCharacters(8),
    })
    .refine(
      (val) => {
        try {
          const date = parse(val, "dd/MM/yyyy", new Date());
          return isValid(date);
        } catch {
          return false;
        }
      },
      { message: "Data de nascimento inválida" },
    ),
  role: z
    .string({ message: messages.requiredField })
    .min(5, { message: messages.minCharacters(5) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
  responsible_name: z
    .string({ message: messages.requiredField })
    .min(5, { message: messages.minCharacters(5) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
  cep: z
    .string({ message: messages.requiredField })
    .refine((val) => clearMask(val).length === 8, {
      message: messages.exactCharacters(8),
    }),
  street: z
    .string({ message: messages.requiredField })
    .min(5, { message: messages.minCharacters(5) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
  number: z
    .string({ message: messages.requiredField })
    .min(1, { message: messages.minCharacters(1) })
    .max(10, {
      message: messages.maxCharacters(255),
    }),
  complement: z
    .string({ message: messages.requiredField })
    .max(255, {
      message: messages.maxCharacters(255),
    })
    .optional()
    .nullable(),
  neighborhood: z
    .string({ message: messages.requiredField })
    .min(5, { message: messages.minCharacters(5) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
  neighbourhood: z
    .string({ message: messages.requiredField })
    .min(5, { message: messages.minCharacters(5) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
  city: z
    .string({ message: messages.requiredField })
    .min(2, { message: messages.minCharacters(2) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
  state: z
    .string({ message: messages.requiredField })
    .min(2, { message: messages.minCharacters(2) })
    .max(255, {
      message: messages.maxCharacters(255),
    }),
  uf: z
    .string({ message: messages.requiredField })
    .length(2, { message: messages.exactCharacters(2) }),
  password: z.string({ message: messages.requiredField }),
  confirm_password: z.string({ message: messages.requiredField }),
  communication_opt_in: z.boolean().optional(),
};

export default UserValidator;
